import React from "react";
import Linkify from "react-linkify";
import { useUserContext } from "store/contexts/userContext";
import { useTeamContext } from "store/contexts/teamContext";
import { useTeamActionContext } from "store/contexts/teamActionContext";

export default ({ post }) => {
  const { user } = useUserContext();
  const { team } = useTeamContext();
  const { teamId } = useTeamActionContext();
  
  // Check if the course was created in the current team
  const isCreatedInCurrentTeam = post.team_id === parseInt(teamId);
  
  // Check if the current user created the course
  const isCreatedByCurrentUser = post.user && user && post.user.id === user.id;
  
  // Check if the current user is an admin in the team
  const isAdmin = team && [2, 3].includes(team.role_id);
  
  // Determine if the user can manage the course - only if they're the creator or admin AND the course was created in this team
  const canManageCourse = (isCreatedByCurrentUser || isAdmin) && isCreatedInCurrentTeam;
  
  return (
    <div className="course-post-content">
      <h4 className="course-title">{post.title || post.data?.content}</h4>
      <Linkify
        properties={{
          target: "_blank",
          style: { color: "red", fontWeight: "bold" },
        }}
      >
        <p className="course-description textContent">{post.description}</p>
      </Linkify>
      
      {/* Course creation info */}
      <div className="course-creation-info" style={{ fontSize: '0.85rem', marginTop: '10px', color: '#666' }}>
        {isCreatedByCurrentUser ? (
          <span>You created this course {!isCreatedInCurrentTeam && ` in ${post.team?.name}`}</span>
        ) : (
          <span>Created by {post.user?.name} {!isCreatedInCurrentTeam && ` in ${post.team?.name}`}</span>
        )}
        
        {/* Course status indicator */}
        <div className="course-status-indicator" style={{ marginTop: '5px', display: 'flex', alignItems: 'center' }}>
          <span 
            className="status-badge" 
            style={{ 
              display: 'inline-block',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '0.75rem',
              backgroundColor: isCreatedInCurrentTeam ? '#e6f7ff' : '#fff7e6',
              color: isCreatedInCurrentTeam ? '#1890ff' : '#fa8c16',
              border: isCreatedInCurrentTeam ? '1px solid #91d5ff' : '1px solid #ffd591',
              marginRight: '5px'
            }}
          >
            {isCreatedInCurrentTeam ? 'Created in this team' : 'Assigned to this team'}
          </span>
        </div>
        
        {/* Course access indicator */}
        <div className="course-access-indicator" style={{ marginTop: '5px', display: 'flex', alignItems: 'center' }}>
          <span 
            className="access-badge" 
            style={{ 
              display: 'inline-block',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '0.75rem',
              backgroundColor: canManageCourse ? '#e6f7ff' : '#f6ffed',
              color: canManageCourse ? '#1890ff' : '#52c41a',
              border: canManageCourse ? '1px solid #91d5ff' : '1px solid #b7eb8f',
              marginRight: '5px'
            }}
          >
            {canManageCourse ? 'Manage' : 'View'}
          </span>
          <span>
            {canManageCourse 
              ? 'You can manage this course' 
              : 'You can view this course'}
          </span>
        </div>
      </div>
    </div>
  );
}; 